const GRID_SIZE = 480;
const LINE_POSITIONS = [0, 64, 120, 168, 208, 240, 272, 312, 360, 416, 480];

export function DecorativeGrid() {
  return (
    <svg
      aria-hidden="true"
      data-slot="empty-state-grid"
      className="pointer-events-none absolute -top-[176px] left-1/2 -translate-x-1/2"
      width={GRID_SIZE}
      height={GRID_SIZE}
      fill="none"
    >
      <defs>
        <radialGradient id="grid-mask">
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor="black" />
        </radialGradient>
        <mask id="grid-fade">
          <rect width={GRID_SIZE} height={GRID_SIZE} fill="url(#grid-mask)" />
        </mask>
      </defs>

      <g mask="url(#grid-fade)">
        {LINE_POSITIONS.map(pos => (
          <line
            key={`v${pos}`}
            x1={pos}
            y1={0}
            x2={pos}
            y2={GRID_SIZE}
            stroke="var(--border-subtle)"
            strokeWidth={1}
          />
        ))}
        {LINE_POSITIONS.map(pos => (
          <line
            key={`h${pos}`}
            x1={0}
            y1={pos}
            x2={GRID_SIZE}
            y2={pos}
            stroke="var(--border-subtle)"
            strokeWidth={1}
          />
        ))}
      </g>
    </svg>
  );
}
